export default __webpack_public_path__ + "27418090b7e93007501c38b4d93c18b4.svg";